var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-container"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Pagina non trovata")]),_c('p',[_vm._v("La pagina che stai cercando non esiste o è stata spostata.")]),_c('router-link',{staticClass:"back-link",attrs:{"to":"/home"}},[_vm._v("Torna alla Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }